var _path, _radialGradient, _radialGradient2, _radialGradient3, _radialGradient4, _radialGradient5, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulgariaToto25From35(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1717.2 271.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h297.3v271.3H0V0zm1076.4 0h640.8v271.3h-640.8V0z",
    fill: "#26448c"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 183.912,
    cy: 190.935,
    r: 14.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6aa5e"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M166.5 193.5c0 7.9 6.5 14.4 14.4 14.4s14.4-6.5 14.4-14.4-6.5-14.4-14.4-14.4c-7.9.1-14.4 6.5-14.4 14.4z",
    fill: "url(#a)",
    style: {
      enableBackground: "new"
    }
  }), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 174.678,
    cy: 47.798,
    r: 14.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6aa5e"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M157.3 50.4c0 7.9 6.5 14.4 14.4 14.4s14.4-6.5 14.4-14.4S179.6 36 171.7 36c-8 0-14.4 6.5-14.4 14.4z",
    fill: "url(#b)",
    style: {
      enableBackground: "new"
    }
  }), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 109.634,
    cy: 101.399,
    r: 14.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6aa5e"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M92.2 104c0 7.9 6.5 14.4 14.4 14.4S121 111.9 121 104s-6.5-14.4-14.4-14.4-14.4 6.5-14.4 14.4z",
    fill: "url(#c)",
    style: {
      enableBackground: "new"
    }
  }), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 182.105,
    cy: 116.656,
    r: 14.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6aa5e"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    fill: "url(#e)",
    style: {
      enableBackground: "new"
    }
  }), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 135.731,
    cy: 164.837,
    r: 14.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6aa5e"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    x: -46.4,
    y: 48.2,
    fill: "url(#f)",
    style: {
      enableBackground: "new"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M308.3 0h765.2v271.3H308.3z",
    fillRule: "evenodd",
    fill: "#f39430"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M308.5 0h-11.2v271.3h11.2V0zm-39.6 105.6c10.2-23.5 3-44.6-34.6-55.5-4.4-.9-9-1.6-13.6-2.1C187.4-15.9-4.6 31.9 20.5 162.8 6.9 86 92.1 25.4 161.6 27.8c-20.8.2-34.1 5.2-48.5 14.5-8.6 5.5-16.6 12.2-23.9 19.5-33.8 21.5-61.8 62.6-61.6 99.4-6.9 13.7-8.5 33.2-4 42.1-2.4-9.7.5-38.7 24.6-56-.9 8.4 0 16.4 3.3 20.8-2.4-5.5-1.8-15.5 1.5-24.7 34.4-26.6 98.7-41.1 146.7-40.2 2.5 6.9 4.9 14.3 7 22-36.1-.9-75.8 7.1-108.6 22.2-3.3-7.3-5.6-13.4-6.5-17.3.7 4.3 2.8 10.7 5.5 17.8-17.8 8.3-33.6 18.7-45.4 30.9-10.8 11.6-16.5 32.5-11.5 43.5-2.1-9.4 5.1-24.5 15.1-34.9 4.6-4.8 10.6-9.4 17.5-13.7 3.4 8.7 13.6 26.4 14.1 27.3-1.5.8-5.4 3.3-9 6.7-1.6-.2-3.3-.5-4.8-.9 1.3.6 2.7 1 4.1 1.5-9.7 9-17 22-10 32.7 3.2 4.9 11 6 16.9 6.3 4.3 11.6 24.1 9.7 38.4 3.8-11.6 1.9-24.1 3.3-29-4.6 5.6-1.1 11.5-3.2 17.7-5.9-6.5 1.2-13 2.5-18.7 2.7.4-4.6 10.6-9.9 19.1-13.1 40 39.7 79.1 20 86.9 12.7 2.2.1 33.8-1.6 41.1-24.6 14.7-9.4 21.5-18.4 24.8-26.6 1.4-4.4.6-9.1-2.3-13 14.6-10.4 18.8-25.9 8.3-36.9 12.3-11.4 13.3-26.5-1.5-36.2zm-8.3 29.5c-2.3-1.1-4.8-2-7.6-2.9-.5-.2-1.1-.3-1.6-.5 2.7-3.1 5.3-6.2 7.6-9.4 2 3.8 2.6 8 1.6 12.8zM216 47.6c-5.3-.3-10.7-.4-16.2-.1-.8-1.9-1.8-2.5-7.8-7.7-4.3-4.9-11-8.9-18.3-10.8 15.9 2.3 30.5 8.3 42.3 18.6zM111 51c17.3-12.9 42-20.3 62.9-15.2 9.2 3.3 14.8 5.1 21.8 11.9-11.6.8-23.5 2.8-35.2 5.8-15.2-8.5-32.8-8.3-50.1-2.1.2-.1.4-.3.6-.4zM34.2 151.9c-2.6 2.5-4.7 5.7-6.6 9.3.6-23.9 18.4-56.5 44.2-78.9C69 86.1 66.4 90 63.9 94c-5.7 7.7-18 33.4-24.3 51.6-1.9 2-3.7 4.1-5.4 6.3zm7.1-8.1c8.4-19.9 25.3-50.9 45.3-72.6 18.1-11.6 38.7-17.6 59.4-13.4-49.1 17.7-84.4 42.7-95.1 77.4-3.5 2.7-6.7 5.6-9.6 8.6zm20.8-16.7C78.1 93 129.8 72.5 167.5 66c5.9 3.4 11.8 7.8 17.5 13.3-3.2-5.6-6.6-10.4-10.4-14.5 5.5-.8 10.8-1.4 15.8-1.7 44.7-2.8 63.6 10.5 59.8 35.2-16.5-3.6-34.1-5.4-51.9-5.6-2.7-5.1-5.5-9.5-8.2-12.7 1.8 3.8 3.7 8 5.6 12.7-49 0-99.4 12.4-133.6 34.4zm141.3-23.8c17.6.6 32.7 3.4 43.1 8.4-2.1 5.2-4.9 10.8-8.5 16.7-8.4-1.7-17.3-2.7-26.5-3.1-2.5-7.8-5.2-15.3-8.1-22zm12.6 97.9c-18.5-2.1-43.2-2.3-76.1 9.1-1.8-1.8-3.6-3.6-5.3-5.6 22.2-6.6 49.6-17.3 70.5-31.4 4.7.2 6.3.3 11.3.9.9 9.9.8 19.1-.4 27zm-23.1 36c-13.1-1.3-35.4-9.7-45.9-20.6 17-7.3 50.2-10 67.4-8.6-3.9 10.3-11.8 21.9-21.5 29.2zm-93.5-26.3c9.6-.3 20.1-2.1 31-5.1 1.7 2 3.4 3.9 5.2 5.8-8.9 3-17.8 6.4-26 10.4-3.6-3.5-7-7.3-10.2-11.1zm19.7-20c2.9 4.2 5.9 8.4 9.2 12.3-10.8 2.7-21.3 4.4-31 5-.9-1.1-1.8-2.3-2.7-3.4 7.4-4.8 15.6-9.6 24.5-13.9zm3.3-1.5c12.2-5.6 25.6-10.2 40-12.6 12.5-2.9 23.4-4 34.8-3.9-17.2 9.9-47.6 24.6-64.8 29.3-3.5-4-6.8-8.4-10-12.8zm92.9-50.4c5.3.1 10.3.4 15 1-.2.3-.5.7-.7 1-2.9 4.8-6.6 9.5-10.9 14-1-5.4-2.1-10.7-3.4-16zm-4.9 0c1.6 6.7 3 13.5 4.1 20.1a108.66 108.66 0 0 1-7.1 6.2c-17.3-.5-34.5 1-51.2 4.1-13 2.4-26.1 7.4-38.3 13.4a254.24 254.24 0 0 1-14-23.9c33.2-12.4 74.2-19.8 106.5-19.9zM74.2 172.8c8.2-4.9 17.6-9.3 27.9-13.2 4.5 10.2 9.5 19.9 12.7 24.8-8.9 4.5-17.2 9.6-24.6 14.4-6.5-9.3-11.6-17-16-26zm10.2 70c-4.2-1-7.6-3.1-9.9-7.2-4.1-6.7 3.1-17.5 11.3-24.6l.9-.6c2.3.3 4.7.5 7.2.6 3.5 4.6 7.3 9.1 11.4 13.3-.7.3-19.6 7.7-20.9 18.5zm95 1.1c-18.1 4.4-38.5 2.6-53.5-8.5-3.4-2.3-6.7-4.8-9.9-7.5 8.4-4.1 17.1-7.3 26.1-10 5 4.6 10.4 8.8 16.1 12.5 8.7 5.6 17 9.4 27.3 11.3-1.9 1-4 1.7-6.1 2.2zm31.5-7.8c-2.4.6-5 1-7.5 1.2 5.1-6.5 9-14.1 12.7-22.1 1-2 1.9-4.1 2.6-6.5 19.7.8 16.9 12.7 9.5 18.4-5.4 4.9-10 6.3-17.3 9zm29.2-19.3c1.7-5.8-2.4-11.5-12.2-13.7-2.6-.5-5.1-.9-7.6-1.3 1.4-8 1.6-17.2.9-27 3.4.4 7 .9 10.8 1.5 7.9 1.7 16 3.6 20 7 .4.3 12.3 8.5-11.9 33.5zm18.5-41.5c-2.7-2.2-7.9-6.7-38.2-9.2-.1-1.1-.3-2.2-.4-3.2 0-.3 9.8-6.5 21.7-20.9 5.4 1.3 10 2.9 13.6 5.1-1.3 2-2.8 4.1-4.6 6.2 3-1.1 5.7-2.3 8.3-3.6 6.7 5.8 7.4 14.2-.4 25.6zM190.1 80zM22.5 171.9zm940.4 30.4h42.7v-98h38.3V69.2H924.6v35.1h38.3v98zm-121.3-73.2v-27.2h21.1c9.6 0 15 5 15 13.7 0 7.6-5.9 13.5-13.1 13.5h-23zm-42.7 73.2h42.7v-40.7h25.5c32.5 0 51.2-16.6 51.2-45.7 0-14.4-4.8-26.3-13.7-34.2-10.2-8.9-25-12.6-51-12.6h-54.7v133.2zm-114.6-65.8c0-25.5 8.9-37.7 27-37.7 16.6 0 25 12.6 25 37.7 0 24.4-8.3 36-25.9 36-17.4.1-26.1-11.8-26.1-36zm-43.1-1.8c0 44 26.4 71.2 69.1 71.2 42.2 0 69-27 69-69.5 0-43.1-26.8-70.6-68.8-70.6-41.4-.1-69.3 27.6-69.3 68.9zm-144.6 67.6h42.7v-97.1H579v97.1h42.7V69.2H496.6v133.1zm-59.1-51.6c-1.1 6.1-1.8 8.7-3.9 12-1.3 2.2-3 4.3-4.8 5.7-3.7 3-8.7 4.4-14.4 4.4-16.6 0-25.7-13.3-25.7-37.5 0-23.7 8.9-36.4 25.3-36.4 8.7 0 15.5 3.7 19.2 10.2 1.5 3 2.2 5.2 3.1 10.5h40.9c-2-14.4-3.9-20.3-8.7-28.1-3.9-6.7-9.1-12-15-15.7-10.2-6.5-24.6-10.2-39.4-10.2-41.6 0-68.6 27.4-68.6 69.5 0 43.6 26.1 70.5 68.4 70.5 28.1 0 48.6-11.3 58.4-32.2 3-6.3 4.3-11.3 5.5-22.7h-40.3zM1571 134.9c0-25.5 8.9-37.7 27-37.7 16.6 0 25 12.6 25 37.7 0 24.4-8.3 36-25.9 36-17.4 0-26.1-11.8-26.1-36zm-43.1-1.9c0 44 26.4 71.2 69.1 71.2 42.2 0 69-27 69-69.5 0-43.1-26.8-70.6-68.8-70.6-41.4 0-69.3 27.7-69.3 68.9zm-89.6 67.7h42.7v-98h38.3V67.6H1400v35.1h38.3v98zm-142.2-65.8c0-25.5 8.9-37.7 27-37.7 16.6 0 24.9 12.6 24.9 37.7 0 24.4-8.3 36-25.9 36-17.3 0-26-11.8-26-36zM1253 133c0 44 26.4 71.2 69.1 71.2 42.2 0 69-27 69-69.5 0-43.1-26.8-70.6-68.8-70.6-41.3 0-69.3 27.7-69.3 68.9zm-89.6 67.7h42.7v-98h38.3V67.6h-119.2v35.1h38.3v98z",
    fill: "#fefefe"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M164.7 119.3c0 7.9 6.5 14.4 14.4 14.4s14.4-6.5 14.4-14.4-6.5-14.4-14.4-14.4-14.4 6.4-14.4 14.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulgariaToto25From35);
export default __webpack_public_path__ + "static/media/bulgaria_toto_2_5_from_35.df4607ba78d71e49de385d4424cf0dc6.svg";
export { ForwardRef as ReactComponent };